import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const PasswordIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_771_39925)">
        <path
          d="M15 7.41667H14.5833V6C14.5833 3.47298 12.527 1.41667 10 1.41667C7.47298 1.41667 5.41667 3.47298 5.41667 6V7.41667H5C4.12698 7.41667 3.41667 8.12698 3.41667 9V17C3.41667 17.873 4.12698 18.5833 5 18.5833H15C15.873 18.5833 16.5833 17.873 16.5833 17V9C16.5833 8.12698 15.873 7.41667 15 7.41667ZM6.58333 6C6.58333 4.11602 8.11602 2.58333 10 2.58333C11.884 2.58333 13.4167 4.11602 13.4167 6V7.41667H6.58333V6ZM15.4167 17C15.4167 17.1105 15.3728 17.2165 15.2946 17.2946C15.2165 17.3728 15.1105 17.4167 15 17.4167H5C4.88949 17.4167 4.78351 17.3728 4.70537 17.2946C4.62723 17.2165 4.58333 17.1105 4.58333 17V9C4.58333 8.88949 4.62723 8.78351 4.70537 8.70537C4.78351 8.62723 4.88949 8.58333 5 8.58333H15C15.1105 8.58333 15.2165 8.62723 15.2946 8.70537C15.3728 8.78351 15.4167 8.88949 15.4167 9V17Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.166667"
        />
      </g>
      <defs>
        <clipPath id="clip0_771_39925">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(PasswordIcon);
